import { createSlice } from "@reduxjs/toolkit";
import {
  GetRemoteControl, // ✅ Fixed: Corrected from getSingleServer
  blockRemoteControl,
  getAllRemoteControl,
  saveRemoteControl,
  updateRemoteControl, // ✅ Fixed: Corrected from updateServer
} from "../actions/remoteControl";

const initialState = {
  servers: [],
  singleServer: null,
  loading: false,
  error: null,
  totalCount:0,
};

const RemoteControlSlice = createSlice({
    name: "remote-control",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder
        // Get Single Server
        .addCase(GetRemoteControl.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(GetRemoteControl.fulfilled, (state, action) => {
          state.loading = false;
          state.singleServer = action.payload;
        })
        .addCase(GetRemoteControl.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Save New Server
        .addCase(saveRemoteControl.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(saveRemoteControl.fulfilled, (state, action) => {
          state.loading = false;
          state.servers.push(action.payload);
        })
        .addCase(saveRemoteControl.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Get All Servers
        .addCase(getAllRemoteControl.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getAllRemoteControl.fulfilled, (state, action) => {
          const { result, totalDocument } = action.payload;
          state.servers = result;
          state.totalCount = totalDocument;
          state.loading = false;
        })
        .addCase(getAllRemoteControl.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Update Server
        .addCase(updateRemoteControl.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateRemoteControl.fulfilled, (state, action) => {
          state.loading = false;
          state.servers = state.servers.map((server) =>
            server.id === action.payload.id ? { ...server, ...action.payload } : server
          );
        })
        .addCase(updateRemoteControl.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
  
        // Block Server
        .addCase(blockRemoteControl.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(blockRemoteControl.fulfilled, (state, action) => {
          state.loading = false;
          state.servers = state.servers.map((server) =>
            server.id === action.payload.id ? { ...server, blocked: true } : server
          );
        })
        .addCase(blockRemoteControl.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
  });
  

export default RemoteControlSlice.reducer;
